import { render } from "./HorizontalNav.vue?vue&type=template&id=004d9a55&scoped=true"
import script from "./HorizontalNav.vue?vue&type=script&lang=js"
export * from "./HorizontalNav.vue?vue&type=script&lang=js"

import "./HorizontalNav.vue?vue&type=style&index=0&id=004d9a55&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-004d9a55"]])

export default __exports__